export const SELECTORS = {
  COOKIE_BANNER: 'js-cookie-banner',
  CLOSE_BTN: 'js-cookie-banner-close-btn'
};

export const IS_BANNER_VISIBLE = 'isCookieBannerVisible';
export const BANNER_VISIBILITY_TIMEOUT = 10000;
